import { getRequest, patchRequest } from "utils/helpers/common/http-methods";

export const NAVIGATION_APIS = {
  getNotificationCount: () => getRequest("/notifications/count"),
  readNotification: () => patchRequest(`/notification/read/all`, {}),
};
